import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=5e5b85a9&"
import script from "./Deposits.vue?vue&type=script&lang=ts&"
export * from "./Deposits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports